import type { AxiosRequestConfig } from "axios"
import type { MaybeRef } from "vue"
import type { ServerResponseV1 } from "@/http"
import type { IWelcomeInvitationConfigResponse } from "@/models/welcomeInvitationConfig"
import { useQuery } from "@tanstack/vue-query"
import { toValue } from "vue"
import { v1 } from "@/axios"
import { WelcomeInvitationConfig } from "@/models/welcomeInvitationConfig"

export interface IGetInvitationConfigArgsParams {
  eventAlbumId?: number
}

export async function getInvitationConfig(eventVaultId: number, albumId?: number) {
  if (!eventVaultId) {
    throw new Error("Missing `eventVaultId` when attempting to get invitation config. Please ensure `eventVaultId` is provided.")
  }

  const options: AxiosRequestConfig = {}

  const params: IGetInvitationConfigArgsParams = {
    eventAlbumId: albumId,
  }

  if (params.eventAlbumId) {
    options.params = params
  }

  const response = await v1.get<ServerResponseV1<IWelcomeInvitationConfigResponse>>(`/events/${eventVaultId}/invitation`, options)

  return WelcomeInvitationConfig.fromResponse(response.data.data)
}

export const GET_INVITATION_CONFIG = "getInvitationConfig"

export function useGetInvitationConfig(eventVaultId?: MaybeRef<number | undefined>, albumId?: MaybeRef<number | undefined>) {
  return useQuery({
    queryKey: [GET_INVITATION_CONFIG, eventVaultId, albumId],
    queryFn: () => getInvitationConfig(toValue(eventVaultId)!, toValue(albumId)),
    enabled: !!toValue(eventVaultId),
  })
}
